import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueMui,
  deepPurpleMui,
  greenMui,
  greyMui,
  orangeMui,
} from "@ryde/theme";

export const AdministrativeModeWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "administrative-mode-wrapper",
})`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;

  .login-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .login-title {
    font-size: 18px;
    font-weight: 600;
    color: ${greyMui._800};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;

    &::after {
      content: "";
      flex: 1;
      height: 1px;
      border-top: 1px dotted ${greyMui._400};
    }
  }

  .password-field-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .password-label {
    font-size: 14px;
    font-weight: 500;
    color: ${greyMui._800};
  }

  .password-input {
    padding: 12px;
    border: 1px solid ${greyMui._400};
    border-radius: 4px;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: ${deepPurpleMui._500};
    }
  }

  .password-gate-obfuscated {
    -webkit-text-security: disc;
  }

  .price-mode-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
    padding: 24px;
    background-color: ${greyMui._50};
    border-radius: 8px;
    margin-top: 8px;
  }

  .current-mode-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    width: 100%;
  }

  .current-mode-label-text {
    font-size: 12px;
    font-weight: 400;
    color: ${greyMui._500};
    text-align: center;
  }

  .current-mode-value {
    font-size: 16px;
    font-weight: 600;
    text-align: center;

    &.mode-client {
      color: ${greenMui._800};
    }

    &.mode-supplier {
      color: ${blueMui._700};
    }

    &.mode-both {
      color: ${orangeMui._800};
    }
  }

  .set-mode-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding-top: 16px;
    border-top: 1px solid ${greyMui._200};
  }

  .set-mode-label {
    font-size: 12px;
    font-weight: 400;
    color: ${greyMui._500};
    text-align: center;
  }

  .price-mode-form-control {
    min-width: 200px;
    width: 100%;
  }
`;
